// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1PbSQ","option":"styles_option__3faEL","selected":"styles_selected__3Oq5u"};